<template>
	<c-modal @close="close" :title="title">

		<c-form ref="form" @valid="submit" class="margin-t-40">

			<div v-if="!edit">
				<h6 class="margin-t-40 margin-b-16">Van wie is deze voormelding?</h6>

				<c-select
					:horizontal="true"
					:label="'Eindklant'"
					:options="endcustomers"
					:required="true"
					v-model="client_id"
					name="client_id"
					ValueName="id"
					DisplayName='name'
					@change="getProducts()">
				</c-select>

                <c-select
                    :horizontal="true"
                    :label="'Project'"
                    :options="projects"
                    :required="false"
                    v-model="project_id"
                    name="project_id"
                    ValueName="id"
                    DisplayName='number'
                    v-if="!newProject">
                </c-select>

                <c-input
                    :label="'Project'"
                    :horizontal="true"
                    type="text"
                    name="project_number"
                    v-model="project_number"
                    required
                    v-if="newProject"/>

                <a @click="addProject" v-if="!newProject" class="c-text-icon td-none color-primary font-heading margin-b-16 h-form-horizontal-margin">
                    <svg class="margin-r-8" viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1" id="plus"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#plus"/></svg>
                    <span>Nieuw project toevoegen</span>
                </a>

				<c-item
					v-for="count in itemCount" :key="count"
					@delete-item="removeItem"
					ref="items"
					:items="products"
					:asns="true">
				</c-item>

				<a @click="addItem" class="c-text-icon td-none color-primary font-heading margin-b-16 h-form-horizontal-margin">
					<svg class="margin-r-8" viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1" id="plus"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#plus"/></svg>
					<span>Nog een artikel toevoegen</span>
				</a>
			</div>

			<div v-else>
				<c-item
					v-for="product in asn.products" :key="product"
					@delete-item="removeItem"
					ref="items"
					:items="products"
					:product="product"
					:edit="true"
					:asns="true">
				</c-item>
			</div>

			<h6 class="margin-t-40">Levering</h6>

			<c-input
				:label="'Ordernummer'"
				:horizontal="true"
				type="text"
				name="reference"
				v-model="reference"
				required />

			<c-radiogroup
				v-model="contract"
				:horizontal="true"
				:options="[
					{value:1, label:'Ja'},
					{value:0, label:'Nee'}
				]"
				:name="'contract'"
				:label="'Contractdata'" />

			<c-datepicker v-if="contract"
				:label="'Startdatum contract'"
				name="startDateContract"
				:horizontal="true"
				v-model="startDateContract"
				:type="edit ? '' : 'future'">
			</c-datepicker>

			<c-datepicker v-if="contract"
				:label="'Einddatum contract'"
				name="endDateContract"
				:horizontal="true"
				v-model="endDateContract"
				:type="edit ? '' : 'future'">
			</c-datepicker>

			<c-datepicker
				:label="'Verwachte leverdatum'"
				name="expected"
				:horizontal="true"
				v-model="expectedDeliveryDate"
				:type="edit ? '' : 'future'">
			</c-datepicker>

			<c-textarea
				:label="'Opmerking'"
				:horizontal="true"
				type="textarea"
				name="comment"
				v-model="comment"
			/>

			<c-radiogroup
				v-model="partialDelivery"
				:horizontal="true"
				:options="[
					{value:1, label:'Ja'},
					{value:0, label:'Nee'}
				]"
				:name="'partial-delivery'"
				:label="'Deellevering'" />

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-b-16 no-margin-b" type="submit" :disabled="submitting">{{edit ? "Voormelding wijzigen" : "Voormelding toevoegen"}}</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CItem from '@components/Item';
import CDatepicker from '@components/form/input/Datepicker';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal, CItem, CDatepicker
	},
	props: {
		title: {
			required: true
		},
		edit: {
			required: false,
			default: false
		},
		asn: {
			type: Object,
			required: false
		},
		edit_products: {
			required: false
		}
	},
	data() {
		return {
			client_id: '',
            project_id: '',
            project_number: '',
			reference: '',
			comment: '',
			expectedDeliveryDate: '',
			partialDelivery: 0,
			itemCount: 1,
			endcustomers: '',
            projects: '',
            newProject: false,
			products: '',
			submitting: false,
			endDateContract: '',
			startDateContract: '',
			contract: 1,
		}
	},
	methods: {
		addItem() {
			this.itemCount++;
		},
        addProject() {
            this.project_id = '';
            this.newProject = true;
        },
		removeItem(product_id) {
			if(this.edit){
				let index = this.asn.products.findIndex( (product) => product.id == product_id);
				this.asn.products.splice(index, 1);
			}
			else {
				this.itemCount--;
			}
		},
		submit() {

			this.submitting = true;
			let asns_data = {
				client_id: this.client_id,
				project_id: this.project_id,
                project_number: this.project_number,
				comment: this.comment,
				expected: this.expectedDeliveryDate,
				partial_delivery: this.partialDelivery,
				reference: this.reference,
				start_date_contract: this.startDateContract,
				end_date_contract: this.endDateContract,
				daas: this.daas
			}

			let data = '';

			let items = {
				items: []
			};

			this.$refs.items.forEach( (component, index) => {
				items['items'][index] = component.getData();
			});

			data = Object.assign(asns_data, items);

			if(this.edit){
				this.$xhr.put('/api/asns/' + this.asn.id, data).then( ( {result}) => {
					this.$store.dispatch('toast/success', {title: 'Voormelding aanpassen', text: 'De voormelding is aangepast'});
					this.close();
					this.$emit('added');
					this.submitting = false;

				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.submitting = false;
					this.$store.dispatch('toast/alert', {title: 'Voormelding aanpassen', text: 'Er is helaas iets fout gegaan bij het aanpassen van de voormelding'});
				});
			}
			else{
				this.$xhr.post('/api/asns', data).then( ( {result}) => {
					this.$store.dispatch('toast/success', {title: 'Voormelding aanmaken', text: 'De voormelding is aangemaakt'});
						this.close();
						this.client_id = '';
						this.project_id = '';
						this.project_number = '';
						this.$refs.form.reset();
						this.$emit('added');
						this.submitting = false;
						this.itemCount = 1;
						this.$refs.items[0].clear();
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.submitting = false;
					this.$store.dispatch('toast/alert', {title: 'Voormelding aanmaken', text: 'Er is helaas iets fout gegaan bij het aanmaken van de voormelding'});
				});
			}
		},
        clearPerClient() {
            this.project_id = '';
            this.project_number = '';
            this.submitting = false;
            this.itemCount = 1;
            this.newProject = false;
        },
		getProducts() {
            this.$xhr.get('/api/clients/' + this.client_id).then( ( {result}) => {
				if(!this.edit){
					this.clearPerClient();
				}
                this.products = result.products;
                this.projects = result.projects;
            }).catch( (e) => {
                this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Producten kunnen niet worden ingeladen'});
            });
		},
		close() {
			this.$emit('close');
		},
	},
	mounted(){
		this.$xhr.get('/api/getallendcustomers').then( ( {result}) => {
				this.endcustomers = result;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klanten kunnen niet worden ingeladen'});
		});

		if(this.edit){
			this.client_id = this.asn.client_id;
			this.project_id = this.asn.project_id;
			this.getProducts();
			this.comment = this.asn.comment;
			this.expectedDeliveryDate = this.asn.expected;
			this.partialDelivery = this.asn.partial_delivery;
			this.reference = this.asn.reference;
			this.startDateContract = this.asn.start_date_contract ?? '';
			this.endDateContract = this.asn.end_date_contract ?? '';
			this.daas = this.asn.daas
			this.contract = this.asn.start_date_contract ? 1 : 0;
		}
	}
}
</script>
